import * as _ from 'underscore';

import { Module } from '../Module';

export class TemplatePreloadService {

  public static $inject = ['$http', '$templateCache'];

  constructor(
    private $http: ng.IHttpService,
    private $templateCache: ng.ITemplateCacheService
  ) {}

  private static TemplatePaths = [
    'omniboxContentAnalytics.html'
  ];

  public preloadTemplates() {
    _.each(TemplatePreloadService.TemplatePaths, template => this.$http.get(template, { cache: this.$templateCache }));
  }

}

Module.instance().service('TemplatePreloadService', TemplatePreloadService);
